export default "__VITE_ASSET__Bqtht7Rk__"